export const GOOGLE_MAPS_API_KEY = 'GOOGLE_MAPS_API_KEY';

export const PLACES_MIN_QUERY_LENGTH = 3;
export const PLACES_DEBOUNCE_MS = 300;
